import * as auth from './auth';
import * as integrations from './integrations';
import * as chat from './chat';
import * as ai from './ai';
import * as schedules from './schedules';
import * as scheduleParser from './scheduleParser';
import * as projects from './projects';

/**
 * Main API service that coordinates between specialized services.
 * This file has been split for better maintainability.
 */
export const api = {
  ...auth,
  ...integrations,
  ...chat,
  ...ai,
  ...schedules,
  ...scheduleParser,
  ...projects,
};

// Re-export common types and constants if needed
export { MONTHLY_LIMIT, isAuthMockMode } from './auth';
export { AVAILABLE_APPS } from './integrations';
